import React from 'react';

/**
 * Admin page title with an optional description and action buttons.
 * <PageHeader title="Products" description="…" actions={<button className="pk-btn …">Add</button>} />
 */
const PageHeader = ({ title, description, actions, extra }) => (
  <header className="adm-head">
    <div className="adm-head__text">
      <h1 className="adm-head__title">{title}</h1>
      {description && <p className="adm-head__sub">{description}</p>}
    </div>
    {(actions || extra) && (
      <div className="adm-head__actions">
        {actions}
        {extra}
      </div>
    )}
  </header>
);

export default PageHeader;
